import { Injectable } from '@angular/core';
import { SoapService } from './soap.service';
import { ApiEndPoints, ApiRoot } from '../../../shared/constants/api-endpoints';
import { environment } from '../../../../environments/environment';

const URL = `${environment.api_gateway}${ApiRoot.ICA_PERSON_INQUIRY}`;
const NS = 'http://TargetNamespace.com/PersonInquiry_GetPersonInquiry_request';

// This method is used to build envelope using emirates id
function buildEnvelope(emiratesId: string): string {
    return `
    <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/"
                      xmlns:per="${NS}">
      <soapenv:Header/>
      <soapenv:Body>
        <per:GetPersonInquiry_request>
          <per:identityNumber>${emiratesId}</per:identityNumber>
        </per:GetPersonInquiry_request>
      </soapenv:Body>
    </soapenv:Envelope>`.trim();
}
export interface PersonInquiryResponse {
    IdentityNumber: string;
    FullNameAr?: string;
    FullNameEn?: string;
    DOB?: string;
    Nationality?: string;
    // ...add more fields as needed
}

@Injectable({ providedIn: 'root' })
export class PersonInquiryService {
    // This method is used to initialize the class instance using soap
    constructor(private soap: SoapService) { }
    /**
     * Fetch person details by Emirates ID.
     * Wraps the generic `SoapService` with a typed response.
     */
    // This method is used to get by emirates id using emirates id
    getByEmiratesId(emiratesId: string) {
        return this.soap.call<PersonInquiryResponse>(
            URL,
            buildEnvelope(emiratesId),
            ApiEndPoints.GET_PERSON_INQUIRY
        );
    }
}
